import { createSlice } from '@reduxjs/toolkit'

// Pending toasts, oldest first: [{ kind: 'success' | 'error', message }].
// A queue rather than one slot per kind, so several notifications dispatched in the
// same tick (e.g. one per password validation message) each get their own toast.
const initialState = {
    queue: []
}

// toolkit sets up the redux and state
const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        setSuccessNotification(state, action) {
            if (action.payload) state.queue.push({ kind: 'success', message: action.payload })
        },
        setErrorNotification(state, action) {
            if (action.payload) state.queue.push({ kind: 'error', message: action.payload })
        },
        // Drops the first `count` entries: the ones the component just toasted. Entries
        // queued after that render sit behind them and are kept.
        dequeueNotifications(state, action) {
            state.queue.splice(0, action.payload)
        }
    }
})

export const { setSuccessNotification, setErrorNotification, dequeueNotifications } = notificationSlice.actions
export default notificationSlice.reducer
